import React from 'react';
import { BodyText, Table } from '@chargify/custom-ui-components';
export type NoInvoicesMsgProps = {
  message: string;
};

export const NoInvoicesMsg = ({ message }: NoInvoicesMsgProps) => (
  <Table.Row
    style={{
      justifyContent: 'center',
      paddingTop: '60px',
      paddingBottom: '300px',
    }}
  >
    <td>
      <BodyText variant={'body1'} color={'gray.main'}>
        {message}
      </BodyText>
    </td>
  </Table.Row>
);
